export default "__VITE_ASSET__BU74bf1E__"